import { Injectable } from '@angular/core';
import { AuthService } from '../auth-service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsInitializer {
  private apiKeyUpdateInterval = 6 * 60 * 60 * 1000; // 6 hour in milliseconds
  private isLoaded = false;

  constructor(private authService: AuthService) {
  }

  async initialize(): Promise<void> {
    try {
      const res = await this.authService.getGoogleKeys().toPromise().catch(err => {
        console.error('Failed to fetch Google Maps API key:', err);
        return null;
      });

      if (res && res.key) {
        console.log('Setting Google Maps API key...');
        await this.loadScript(res.key)
          .catch(err => console.error('Error loading Google Maps script:', err));
      } else {
        console.error('No Google Maps API key found in response');
      }
    } catch (e) {
      console.error('Unexpected error during Google Maps initialization:', e);
    }

    // Set up an interval to refresh the key (by reloading)
    setInterval(() => {
      this.reloadPage();
    }, this.apiKeyUpdateInterval);
  }

  private loadScript(key: string): Promise<void> {
    if (this.isLoaded) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.isLoaded = true;
        resolve();
      };
      script.onerror = (error) => reject(error);
      document.head.appendChild(script);
    });
  }

  private reloadPage(): void {
    console.log('Reloading page to apply new Google Maps API key');
    window.location.reload();
  }
}
